import { DOMAINS } from "../../common/common-constants";
import { isProdEnvironment } from "../../common/api-util";
import order_converter from "../../util/order_converter";
import {   newDefaultAsapGHDeliveryOrder } from "../../util/mock_orders";
import { newDefaultOrderView } from "../../util/mock_views";
import { OrderType } from "./foodPrepTimeConstants";

const simModeHeaders = {
  "gh-targeting": JSON.stringify({
    targeting_algorithm: "REAL",
    versions: { "CONFIRMATION-EMAIL-SERVICE": "SIM-*" },
  }),
};

class FoodPrepTimeService {
  constructor($http, $location, $stateParams, $window) {
    this.$http = $http;
    this.$location = $location;
    this.$stateParams = $stateParams;
    this.$window = $window;

    this.confirmedOrder = order_converter.convert({order: newDefaultAsapGHDeliveryOrder, view: newDefaultOrderView});
  }

  testFoodPrepTime() {
    return "foodPrepTimeStepper";
  }

  setConfirmedOrder(confirmedOrder) {
    this.confirmedOrder = confirmedOrder;
  }

  getConfirmedOrder() {
    return this.confirmedOrder;
  }

  get isProdEnvironment() {
    const hostname =  this.$window.location.hostname;
    return isProdEnvironment(hostname)
  }

  /*
   Updates the supervisor token based on the order type for sim mode.
   supervisorToken in SIM Mode:
    starts with a `p` = Pickup
    starts with a `g` = Grubhub Delivery
    else = Self-Delivery
  */
  updateSupervisorToken(isSimModeEnabled, supervisorToken) {
    if (!isSimModeEnabled) {
      return supervisorToken
    }
    const orderType = this.$location.search().orderType;
    if (orderType === OrderType.GRUBHUB_DELIVERY) {
      return `g${supervisorToken}`;
    }
    if (orderType === OrderType.PICKUP) {
      return `p${supervisorToken}`;
    }
    return supervisorToken;
  }

  getConfirmationURL(prepMins, isSimModeEnabled) {
    const domain = this.isProdEnvironment
      ? DOMAINS.ORDER_PROCESSING.PROD
      : DOMAINS.ORDER_PROCESSING.PRE_PROD;
    const { authToken, supervisorToken } = this.$stateParams;
    const newSupervisorToken = this.updateSupervisorToken(isSimModeEnabled, supervisorToken)
    return `${domain}/order/email/confirm/${authToken}/${newSupervisorToken}?foodPrepDuration=${prepMins}`;
  }

  getIsSimModeEnabled() {
    const isSimModeEnabled = this.$location.search().isSimMode === "true";
    return !this.isProdEnvironment && isSimModeEnabled;
  }

  postOrderConfirm(prepMins) {
    const isSimModeEnabled = this.getIsSimModeEnabled();
    const confirmationURL = this.getConfirmationURL(prepMins, isSimModeEnabled);
    const headers = isSimModeEnabled ? { headers: simModeHeaders } : undefined;
    return this.$http.post(confirmationURL, undefined, headers);
  }
}

FoodPrepTimeService.$inject = ["$http", "$location", "$stateParams", "$window"];

export default FoodPrepTimeService;



// WEBPACK FOOTER //
// ./client/app/components/foodPrepTime/foodPrepTime.service.js